(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ContextMenu", [], factory);
	else if(typeof exports === 'object')
		exports["ContextMenu"] = factory();
	else
		root["ContextMenu"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 6);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 1 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(14)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(12)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(5),
  /* template */
  __webpack_require__(10),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1931f86e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tree-child-component',
  props: ['itemchildren', 'float'],
  methods: {
    fnHandler: function fnHandler(item) {
      this.$emit('childhandler', item);
    }
  }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tree_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tree_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Tree_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'context-menu-component',
  components: {
    Tree: __WEBPACK_IMPORTED_MODULE_0__Tree_vue___default.a
  },
  data: function data() {
    return {
      floatDirection: 'float-statue-1'
    };
  },

  props: {
    contextMenuData: {
      type: Object,
      requred: false,
      default: function _default() {
        return {
          menuName: null,
          axis: {
            x: null,
            y: null
          },
          menulists: [{
            fnHandler: '',
            icoName: '',
            btnName: ''
          }]
        };
      }
    },
    transferIndex: {
      type: Number,
      default: 0
    }
  },
  watch: {
    'contextMenuData.axis': function contextMenuDataAxis(val) {
      var x = val.x;
      var y = val.y;
      var innerWidth = window.innerWidth;
      var innerHeight = window.innerHeight;
      var _this = this;
      var index = _this.transferIndex;
      var menuName = 'vue-contextmenuName-' + _this.contextMenuData.menuName;
      var menu = document.getElementsByClassName(menuName)[index];
      menu.style.display = 'block';
      var menuHeight = this.contextMenuData.menulists.length * 30;
      var menuWidth = 150;
      menu.style.top = (y + menuHeight > innerHeight ? innerHeight - menuHeight : y) + 'px';
      menu.style.left = (x + menuWidth > innerWidth ? innerWidth - menuWidth : x) + 'px';
      document.addEventListener('mouseup', function (e) {
        // 解决mac电脑在鼠标右键后会执行mouseup事件
        if (e.button === 0) {
          menu.style.display = 'none';
        }
      }, false);
      if (x + 2 * menuWidth > innerWidth && y + 2 * menuHeight > innerHeight) {
        this.floatDirection = 'float-status-4';
      }
      if (x + 2 * menuWidth < innerWidth && y + 2 * menuHeight > innerHeight) {
        this.floatDirection = 'float-status-1';
      }
      if (x + 2 * menuWidth > innerWidth && y + 2 * menuHeight < innerHeight) {
        this.floatDirection = 'float-status-3';
      }
      if (x + 2 * menuWidth < innerWidth && y + 2 * menuHeight < innerHeight) {
        this.floatDirection = 'float-status-2';
      }
    }
  },
  methods: {
    fnHandler: function fnHandler(item) {
      this.$emit(item.fnHandler);
    }
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VueContextMenu_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VueContextMenu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__VueContextMenu_vue__);

var VueContextMenu = {
	install: function install(Vue) {
		Vue.component('VueContextMenu', __WEBPACK_IMPORTED_MODULE_0__VueContextMenu_vue___default.a);
	}
};
/* harmony default export */ __webpack_exports__["default"] = (VueContextMenu);

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, ".vue-contextmenu-listWrapper[data-v-1931f86e]{display:none;position:fixed;z-index:9999;background:#fff;top:0;left:0;border-radius:2px;box-shadow:0 2px 2px 0 #ccc;font-family:Courier New,Courier,monospace;font-size:12px}.vue-contextmenu-listWrapper .context-menu-list[data-v-1931f86e]{position:relative;background:#fff;text-decoration:none;list-style:none;margin:3px 0}.context-menu-list[data-v-1931f86e]:hover{background:#2894f8}.context-menu-list .has-child[data-v-1931f86e]{position:relative;cursor:pointer;padding:5px 10px}.context-menu-list:hover>.has-child>.child-ul-wrapper[data-v-1931f86e]{display:block}.parent-name .icon[data-v-1931f86e]{position:absolute;display:block;top:4px;right:0;border-top:4px solid transparent;border-left:8px solid #111;border-bottom:4px solid transparent;border-right:4px solid transparent}.no-child-btn[data-v-1931f86e]{padding:5px 10px;cursor:pointer}.nav-icon-fontawe[data-v-1931f86e]{position:absolute;left:0}.nav-name-right[data-v-1931f86e]{margin:0 20px;height:16px;line-height:16px;display:block}.no-allow[data-v-1931f86e]{color:#d3cfcf;cursor:not-allowed}.btn-wrapper-simple[data-v-1931f86e]{position:relative;height:16px;line-height:16px}", ""]);

// exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, ".float-status-1[data-v-65699d5f]{left:100%;bottom:-1px;z-index:10001}.float-status-2[data-v-65699d5f]{left:100%;top:-1px;z-index:10001}.float-status-3[data-v-65699d5f]{right:100%;top:-1px;z-index:10001}.float-status-4[data-v-65699d5f]{right:100%;bottom:-1px;z-index:10001}.child-ul-wrapper .has-child[data-v-65699d5f]{padding:5px 10px;position:relative}li[data-v-65699d5f]{list-style:none}.parent-name .icon[data-v-65699d5f]{position:absolute;display:block;top:4px;right:0;border-top:4px solid transparent;border-left:8px solid #111;border-bottom:4px solid transparent;border-right:4px solid transparent}.no-child-btn[data-v-65699d5f]{padding:5px 10px}.child-ul-wrapper[data-v-65699d5f]{background:#fff;position:absolute;display:none;border:1px solid #e8e8e8;border-radius:3px}.child-li-wrapper:hover>.has-child>.child-ul-wrapper[data-v-65699d5f]{display:block}.child-li-wrapper[data-v-65699d5f]:hover,.context-menu-list[data-v-65699d5f]:hover{background:#2894f8}.nav-icon-fontawe[data-v-65699d5f]{position:absolute}.nav-name-right[data-v-65699d5f]{white-space:nowrap;display:block;margin:auto 20px}.btn-wrapper-simple[data-v-65699d5f]{position:relative;height:16px;line-height:16px}", ""]);

// exports


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(13)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(4),
  /* template */
  __webpack_require__(11),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-65699d5f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "vue-contextmenu-listWrapper",
    class: 'vue-contextmenuName-' + _vm.contextMenuData.menuName,
    on: {
      "contextmenu": function($event) {
        $event.stopPropagation();
      }
    }
  }, _vm._l((_vm.contextMenuData.menulists), function(item) {
    return _c('li', {
      key: item.btnName,
      staticClass: "context-menu-list"
    }, [(item.children && item.children.length > 0) ? _c('div', {
      staticClass: "has-child"
    }, [_c('div', {
      staticClass: "parent-name btn-wrapper-simple",
      class: {
        'no-allow': item.disabled ? item.disabled : false
      }
    }, [_c('i', {
      staticClass: "nav-icon-fontawe",
      class: item.icoName ? item.icoName : ''
    }), _vm._v(" "), _c('span', {
      staticClass: "nav-name-right"
    }, [_vm._v(_vm._s(item.btnName))]), _vm._v(" "), _c('i', {
      staticClass: "icon"
    })]), _vm._v(" "), _c('Tree', {
      attrs: {
        "itemchildren": item.children,
        "float": _vm.floatDirection
      },
      on: {
        "childhandler": _vm.fnHandler
      }
    })], 1) : _c('div', [_c('div', {
      staticClass: "no-child-btn btn-wrapper-simple",
      class: {
        'no-allow': item.disabled ? item.disabled : false
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          item.disabled === true ? '' : _vm.fnHandler(item)
        }
      }
    }, [_c('i', {
      staticClass: "nav-icon-fontawe",
      class: item.icoName ? item.icoName : ''
    }), _vm._v(" "), _c('span', {
      staticClass: "nav-name-right"
    }, [_vm._v(_vm._s(item.btnName))])])])])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "child-ul-wrapper",
    class: _vm.float
  }, _vm._l((_vm.itemchildren), function(i) {
    return _c('li', {
      key: i.name,
      staticClass: "child-li-wrapper"
    }, [(i.children && i.children.length > 0) ? _c('div', {
      staticClass: "has-child"
    }, [_c('div', {
      staticClass: "parent-name btn-wrapper-simple"
    }, [_c('i', {
      staticClass: "nav-icon-fontawe",
      class: i.icoName ? i.icoName : ''
    }), _vm._v(" "), _c('span', {
      staticClass: "nav-name-right"
    }, [_vm._v(_vm._s(i.btnName))]), _vm._v(" "), _c('i', {
      staticClass: "icon"
    })]), _vm._v(" "), _c('tree-child-component', {
      attrs: {
        "itemchildren": i.children,
        "float": _vm.float
      },
      on: {
        "childhandler": _vm.fnHandler
      }
    })], 1) : _c('div', [_c('div', {
      staticClass: "no-child-btn btn-wrapper-simple",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.fnHandler(i)
        }
      }
    }, [_c('i', {
      staticClass: "nav-icon-fontawe",
      class: i.icoName ? i.icoName : ''
    }), _vm._v(" "), _c('span', {
      staticClass: "nav-name-right"
    }, [_vm._v(_vm._s(i.btnName))])])])])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(7);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6b12b0a8", content, true, {});

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(8);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("007c7502", content, true, {});

/***/ }),
/* 14 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// vue-contextmenu.min.js